<div class="chat-custom-dropdown chat-custom-dropdown-outgoing" #chatCustomDropDown144823 data-dropdown>

  <div class="media profile-media chat-custom-dropbtn flex-vr-center"
    (click)="toggleFileInputButton($event, null, chatCustomDropDown144823, 3)">
    <img class="rounded-circle h-40px w-40px" [src]="vars?.user?.avatar ?? vars?.dummyImage" alt="">
    <div class="media-body"><span>{{vars?.user?.full_name | titlecase}}</span>
      <p class="mb-0 font-roboto text-start"> {{vars?.user?.is_agent ? 'Agent' : 'Admin'}} <i
          class="middle fa fa-angle-down"></i>
      </p>
    </div>
  </div>
  <!-- <ul class="profile-dropdown onhover-show-div"> -->
  <div
    class="chat-custom-dropdown-menu reactions-list menu-files-attachments menu-file-input ms-n30px mt-2 start-0 w-auto py-1">
    <div class="menu-contents file-picker-attachments px-2">
      <ul class="profile-dropdown">
        <!-- <li><a href="/user/profile"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span></a></li>
        <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li>
        <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li>
        <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li> -->
        <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Log out</span>
          <!-- <div>
        {{vars?.user?.email}}
      </div> -->
        </li>
      </ul>
    </div>
  </div>
</div>